tailwind.config = {
  theme: {
    extend: {
      colors: {
        transparent: 'transparent',
        current: 'currentColor',
        primary: {
          gold: '#DEC48E',
          'gold-2': '#6F6443',
        },
        secondary: {
          grey: '#2A2A2A',
          'grey-2': '#38362F',
        },
        dots: '#DBC291',
      },
      fontSize: {
        sm: '14px',
        base: '16px',
        lg: '18px',
        xl: '20px',
        '2xl': '24px',
        '3xl': '30px',
        '4xl': '36px',
        '5xl': '48px',
        '6xl': '60px',
        '9xl': '128px',
      },
      extend: {
        typography: {
          DEFAULT: {
            css: {
              color: '#DEC48E',
              a: {
                color: '#3182ce',
                '&:hover': {
                  color: '#2c5282',
                },
              },
            },
          },
        },
        spacing: {
          '12px': '12px',
        },
      },
    },
  },
}
